import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SaveInitialContactScriptFormParams } from "../types/SaveInitialContactScriptFormParams";
import { SaveCallScriptFormResult } from "../types/SaveCallScriptFormResult";

export const useSaveInitialContactScriptForm = (
	params: SaveInitialContactScriptFormParams,
	onSuccess: (result: SaveCallScriptFormResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	method = 'save-initialContactForm';
	requestParams = {
		retailOrderID: params.formObject.retailOrderID,
		retailOrderNo: params.formObject.retailOrderNo,
		mayISpeakToCheckBox: params.formObject.mayISpeakToCheckBox,
		introduceYourselfCheckBox: params.formObject.introduceYourselfCheckBox,
		confirmCustomerCheckBox: params.formObject.confirmCustomerCheckBox,
		lowesSurveyScoreCheckBox: params.formObject.lowesSurveyScoreCheckBox,
		verifyFollowingCheckBox: params.formObject.verifyFollowingCheckBox,
		jobAddressText: params.formObject.jobAddressText,
		methodOfCommunicationEmailCheckBox: params.formObject.methodOfCommunicationEmailCheckBox,
		methodOfCommunicationCallCheckBox: params.formObject.methodOfCommunicationCallCheckBox,
		methodOfCommunicationTextCheckBox: params.formObject.methodOfCommunicationTextCheckBox,
		newOrExistingCabinetsCheckBox: params.formObject.newOrExistingCabinetsCheckBox,
		ifExistingCabinetsCheckBox: params.formObject.ifExistingCabinetsCheckBox,
		whoRemovedText: params.formObject.whoRemovedText,
		ifNewCabinetsCheckBox: params.formObject.ifNewCabinetsCheckBox,
		specialtyCabinetsAndMirrorsCheckBox: params.formObject.specialtyCabinetsAndMirrorsCheckBox,
		roomOrLocationCheckBox: params.formObject.roomOrLocationCheckBox,
		roomOrLocationText: params.formObject.roomOrLocationText,
		colorAndFinishCheckBox: params.formObject.colorAndFinishCheckBox,
		ifNaturalStoneYesCheckBox: params.formObject.ifNaturalStoneYesCheckBox,
		ifNaturalStoneNoCheckBox: params.formObject.ifNaturalStoneNoCheckBox,
		colorOrFinishEdgeText: params.formObject.colorOrFinishEdgeText,
		backsplashSlabCheckBox: params.formObject.backsplashSlabCheckBox,
		backsplashCustomerSuppliedCheckBox: params.formObject.backsplashCustomerSuppliedCheckBox,
		ifSlabThickness3cmCheckBox: params.formObject.ifSlabThickness3cmCheckBox,
		ifSlabThickness2cmCheckBox: params.formObject.ifSlabThickness2cmCheckBox,
		standard4CheckBox: params.formObject.standard4CheckBox,
		fullHeightCheckBox: params.formObject.fullHeightCheckBox,
		extendedOverhangsCheckBox: params.formObject.extendedOverhangsCheckBox,
		supportCheckBox: params.formObject.supportCheckBox,
		customerSuppliedCheckBox: params.formObject.customerSuppliedCheckBox,
		installerProvidedCheckBox: params.formObject.installerProvidedCheckBox,
		otherText: params.formObject.otherText,
		extendedOverhangsText: params.formObject.extendedOverhangsText,
		makeText: params.formObject.makeText,
		modelText: params.formObject.modelText,
		suppliedCheckBox: params.formObject.suppliedCheckBox,
		sinkInstallerCheckBox: params.formObject.sinkInstallerCheckBox,
		customerCheckBox: params.formObject.customerCheckBox,
		undermountCheckBox: params.formObject.undermountCheckBox,
		dropInCheckBox: params.formObject.dropInCheckBox,
		apronCheckBox: params.formObject.apronCheckBox,
		chipMinimizerYesCheckBox: params.formObject.chipMinimizerYesCheckBox,
		chipMinimizerNoCheckBox: params.formObject.chipMinimizerNoCheckBox,
		customerResponsibilityToRemoveCheckBox: params.formObject.customerResponsibilityToRemoveCheckBox,
		faucetMakeCheckBox: params.formObject.faucetMakeCheckBox,
		numberOfHoles: params.formObject.numberOfHoles,
		hotOrColdWaterDispenserCheckbox: params.formObject.hotOrColdWaterDispenserCheckbox,
		soapPumpCheckBox: params.formObject.soapPumpCheckBox,
		glassRinserCheckBox: params.formObject.glassRinserCheckBox,
		airSwitchCheckBox: params.formObject.airSwitchCheckBox,
		faucetMakeText: params.formObject.faucetMakeText,
		faucetModelText: params.formObject.faucetModelText,
		numberOfHolesText: params.formObject.numberOfHolesText,
		plumbingDisconnectInstallerCheckBox: params.formObject.plumbingDisconnectInstallerCheckBox,
		plumbingDisconnectCheckBox: params.formObject.plumbingDisconnectCheckBox,
		plumbingCustomerCheckBox: params.formObject.plumbingCustomerCheckBox,
		plumbingReconnectCheckBox: params.formObject.plumbingReconnectCheckBox,
		plumbingReconnectInstallerCheckBox: params.formObject.plumbingReconnectInstallerCheckBox,
		plumbingReconnectCustomerCheckBox: params.formObject.plumbingReconnectCustomerCheckBox,
		freeStandingCheckBox: params.formObject.freeStandingCheckBox,
		slideInCheckBox: params.formObject.slideInCheckBox,
		cooktopCheckBox: params.formObject.cooktopCheckBox,
		closingDiscussCustomerCheckBox: params.formObject.closingDiscussCustomerCheckBox,
		discussCustomerAvailabilityCheckBox: params.formObject.discussCustomerAvailabilityCheckBox,
		scheduleProjectCheckBox: params.formObject.scheduleProjectCheckBox,
		lowesSurveyExpectationCheckBox: params.formObject.lowesSurveyExpectationCheckBox,
		provideYourContactCheckBox: params.formObject.provideYourContactCheckBox,
		emailText: params.formObject.emailText,
		contactNameText: params.formObject.contactNameText,
		phoneNumberText: params.formObject.phoneNumberText,
		chipMinimizerCheckbox: params.formObject.chipMinimizerCheckBox,
		plumbingOfferCheckBox: params.formObject.plumbingOfferCheckBox,
		plumbingConnectionsCheckBox: params.formObject.plumbingConnectionsCheckBox,
		plumbing1120679CheckBox: params.formObject.plumbing1120679CheckBox,
		plumbing1120669CheckBox: params.formObject.plumbing1120669CheckBox,
		granite1120680Checkbox: params.formObject.granite1120680Checkbox,
		granite1120686Checkbox: params.formObject.granite1120686Checkbox,
		granite1120685Checkbox: params.formObject.granite1120685Checkbox,
		granite1120684Checkbox: params.formObject.granite1120684Checkbox,
		quartz1120670Checkbox: params.formObject.quartz1120670Checkbox,
		quartz1120676Checkbox: params.formObject.quartz1120676Checkbox,
		quartz1120675Checkbox: params.formObject.quartz1120675Checkbox,
		quartz1120674Checkbox: params.formObject.quartz1120674Checkbox,
		plumbingNotOfferDisconnectCheckBox: params.formObject.plumbingNotOfferDisconnectCheckBox,
		plumbingNotOfferDisconnectInstallerCheckbox: params.formObject.plumbingNotOfferDisconnectInstallerCheckbox,
		plumbingNotOfferDisconnectCustomerCheckbox: params.formObject.plumbingNotOfferDisconnectCustomerCheckbox,
		plumbingNotOfferReconnectCheckBox: params.formObject.plumbingNotOfferReconnectCheckBox,
		plumbingNotOfferReconnectInstallerCheckbox: params.formObject.plumbingNotOfferReconnectInstallerCheckbox,
		plumbingNotOfferReconnectCustomerCheckbox: params.formObject.plumbingNotOfferReconnectCustomerCheckbox,
		appliancesMakeText: params.formObject.appliancesMakeText,
		appliancesModelText: params.formObject.appliancesModelText,
		appliancesMakeCheckBox: params.formObject.appliancesMakeCheckBox,
		appliancesDropInCheckBox: params.formObject.appliancesDropInCheckBox,
		noteText: params.formObject.noteText,
		granite5YearCheckBox: params.formObject.granite5YearCheckBox,
		granite10YearCheckBox: params.formObject.granite10YearCheckBox,
		backsplashCheckBox: params.formObject.backsplashCheckBox,
	};

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/" + method, requestParams) as SaveCallScriptFormResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess) {
				onSuccess(result);
			}
			else
				onError(`Error when saving the pdf file"}: ` +
					result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}